import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { Guide } from './types';

export type SaveGuideStepOrderOptions = CommonRequestOptions;

export type SaveGuideStepOrderResult = Guide;

export async function saveGuideStepOrder(
   guideid: number,
   revisionid: number,
   stepids: number[],
   common: SaveGuideStepOrderOptions = {}
): Promise<SaveGuideStepOrderResult> {
   return makeRequest('put', `guides/${guideid}/steporder`, {
      ...common,
      query: {
         revisionid,
      },
      body: {
         stepids,
      },
   });
}
